import { render } from "./ConfirmSendMonthlyReport.vue?vue&type=template&id=075cd160"
import script from "./ConfirmSendMonthlyReport.vue?vue&type=script&lang=js"
export * from "./ConfirmSendMonthlyReport.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__